<template>
  <div
    class="fixed_box"
    ref="begin_box"
  >
    <div
      class="good_list_warp"
      :style="{left:location+'px'}"
      ref="good_list_warp"
    >
      <swiper :options="swiperOption" style="width:100%;">
        <swiper-slide
          class="good_list_warp"
          v-for="(tempGood,index) in getGoodList"
          :key="index"
        >
          <div
            class="good_list_item"
           
            :key="`tempGood_${index}_first`"
          >
            <good-card :info="tempGood[0]" v-if="tempGood[0]!=undefined"></good-card>
          </div>
          <div
            class="good_list_item"
          
            :key="`tempGood_${index}_secound`"
          >
            <div style="height:250px">
              <good-card
                :show-detail="false"
                :info="tempGood[1]"
                v-if="tempGood[1]!=undefined"
              ></good-card>
            </div>
            <div style="height:250px">
              <good-card
                :show-detail="false"
                :info="tempGood[2]"
                v-if="tempGood[2]!=undefined"
              ></good-card>
              
            </div>
          </div>
          <div
            class="good_list_item"
            :key="`tempGood_${index}_thrid`"
          >
            <good-card :info="tempGood[3]" v-if="tempGood[3]!=undefined"></good-card>
          </div>
          <div
            class="good_list_item"
            :key="`tempGood_${index}_fourth`"
          >
            <div style="height:250px">
              <good-card
                :show-detail="false"
                :info="tempGood[4]"
                v-if="tempGood[4]!=undefined"
              ></good-card>
            </div>
            <div style="height:250px">
              <good-card
                :show-detail="false"
                :info="tempGood[5]"
                v-if="tempGood[5]!=undefined"
              ></good-card>
            </div>
          </div>
        </swiper-slide>
        <div
          class="swiper-pagination"
          slot="pagination"
        ></div>
        <div
          class="swiper-button-prev"
          slot="button-prev"
        ></div>
        <div
          class="swiper-button-next"
          slot="button-next"
        ></div>
      </swiper>

    </div>

  </div>
</template>

<script>
import GoodCard from '@/components/GoodCard/index.vue'
import { searchGoods, searchGoodsByType } from '@/api/good'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
export default {
  data() {
    return {
      width: '275px',
      // stepWidth: 1100, //左右按钮移动
      location: 0,
      isLeftDisable: true,
      isRightDisable: false,
      swiperOption: {
        slidesPerView: 1,
        spaceBetween: 30,
        loop: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      }
    }
  },
  props:{
    goodList:{
      type:Array,
      required:true
    }
  },
  components: {
    GoodCard,
    swiper,
    swiperSlide
  },
  created() {
    this.init()
  },
  mounted() {
    this.width = this.$refs.begin_box.clientWidth / 4 + 'px!important'
  },
  computed: {
    getGoodList() {
      let _goodList = []
      let _tempList = []
      this.goodList.forEach((ele, index) => {
        _tempList.push(ele)
        if (index % 6 == 5) {
          _goodList.push(_tempList)
          _tempList = []
          
        }
      })
      if (_tempList.length > 0) {
        _goodList.push(_tempList)
      }
      // console.log(_goodList)             
      return _goodList
    }
  },
  methods: {
    //初始化
    init() {
      // this.initData()
    },
    //初始化数据，先按全部分类取商品
    initData() {
      const store_no = 50
      const type = 2
      searchGoods(store_no, type).then(res => {
        // let types = res.data.type
        // types.forEach(type => {
          searchGoodsByType(50, 40).then(res => {
            this.goodList = this.goodList.concat(res.data.goods)
          })
        // })

      })
    },
    // goLeft() {
    //   let target = this.location + this.stepWidth
    //   this.isLeftDisable = true
    //   this.isRightDisable = true
    //   let goTimer = setInterval(() => {
    //     if (this.location >= target) {
    //       if (this.location < 0) {
    //         this.isLeftDisable = false
    //       }
    //       if (this.location > 0 - this.$refs.good_list_warp.clientWidth) {
    //         this.isRightDisable = false
    //       }
    //       clearInterval(goTimer)
    //     } else {
    //       this.location += 100
    //     }
    //   }, 5)
    // },
    // goRight() {
    //   let target = this.location - this.stepWidth
    //   this.isLeftDisable = true
    //   this.isRightDisable = true
    //   let goTimer = setInterval(() => {
    //     if (this.location <= target) {
    //       if (this.location < 0) {
    //         this.isLeftDisable = false
    //       } else {
    //         this.isLeftDisable = true
    //       }
    //       if (this.location > 0 - this.$refs.good_list_warp.clientWidth) {
    //         this.isRightDisable = true
    //       } else {
    //         this.isRightDisable = false
    //       }
    //       clearInterval(goTimer)
    //     } else {
    //       this.location -= 100
    //     }
    //   }, 5)
    // }
  }
}
</script>

<style lang="scss" scoped>
.fixed_box {
  width: 100%;
  overflow: hidden;
  position: relative;
  .buttonOpacity {
    opacity: 0.7;
  }
  .good_list_warp {
    position: relative;
    display: flex;
    flex-wrap: nowrap;
    flex-direction: row;
    .good_list_item {
      width: 275px!important;
      height: 500px;
    }
  }
  .fixed_action {
    z-index: 3;
    opacity: 80%;
    .go_left {
      position: absolute;
      left: 0;
      top: calc(50% - 20px);
    }
    .go_right {
      position: absolute;
      right: 0;
      top: calc(50% - 20px);
    }
  }
}
</style>

